import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Project } from 'src/app/core/objects/project';
import { CargoSpacesSummaryService } from '../../../core/services/cargo-spaces-summary.service';
import { ProjectService } from '../../../core/services/project.service';
import { SharedProjectService } from '../../../core/services/shared-project.service';
import { CargoSpace, CargoSpaceSummary } from '../../../core/types';

@Component({
    selector: 'gl-loading-space-panel',
    templateUrl: './loading-space-panel.component.html',
    styleUrls: ['./loading-space-panel.component.scss'],
    standalone: false
})
export class LoadingSpacePanelComponent implements OnInit {
  public cargoSpaces: CargoSpace[];
  public cargoSpacesSummary: CargoSpaceSummary[];
  public project: Project;
  public currentWorkSpaceIndex: number;
  public currentStopIndex: number;
  @Input() isClosed = false;
  @HostBinding('class.isMobile') public isMobile: boolean;

  constructor(
    public cargoSpacesSummaryService: CargoSpacesSummaryService,
    private sharedProjectService: SharedProjectService,
    private projectService: ProjectService,
    private router: Router,
  ) {
    this.isMobile = this.router.url.includes('mobile');
    this.projectService.currentWorkSpaceIndex.subscribe(
      (currentWorkSpaceIndex) => (this.currentWorkSpaceIndex = currentWorkSpaceIndex),
    );
    this.projectService.currentStopIndex.subscribe((current) => (this.currentStopIndex = current));
    this.projectService.project.subscribe((project) => {
      this.project = project;
      this.cargoSpaces = this.currentStopIndex >= 0
        ? project.workSpaces[this.currentWorkSpaceIndex].stops[this.currentStopIndex].cargoSpaces
        : project.workSpaces[this.currentWorkSpaceIndex]?.cargoSpaces;
      if (this.cargoSpaces?.length > 0 && this.currentStopIndex >= 0) {
        this.cargoSpacesSummary = this.cargoSpacesSummaryService.calculateCargoSpacesSummary(
          this.currentWorkSpaceIndex,
          this.currentStopIndex,
          project,
          true
        );

      } else {
        this.cargoSpacesSummary = this.cargoSpacesSummaryService.calculateCargoSpacesSummary(
          this.currentWorkSpaceIndex,
        );
      }
    });

  }

  public ngOnInit() {
    if (this.project.workSpaces.length === 0) {
      return;
    }
  }

  public isClosedEvent(isClosed: boolean): void {
    this.isClosed = isClosed;
  }

  public isViewingSharedProject(): Observable<boolean> {
    return this.sharedProjectService.isViewingShared;
  }
}
